import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-126747ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tips" }
const _hoisted_2 = { class: "txt" }
const _hoisted_3 = { class: "infoList" }

import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { queryChannelInfo } from "@/api/userCenter";
import { getCookie } from "@/utils/cookies";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const userName = ref("");
const store = useStore();
const isMobile = computed(() => !!store.state.isMobile);
const router = useRouter();
const route = useRoute();
const init = () => {
  queryChannelInfo({
    channelNo: (route.query.ch as string) || "-",
  }).then((res) => {
    userName.value = res.data.channelName || "-";
  });
};
init();
const showRegister = () => {
  if (getCookie("token")) {
    router.push({ name: "home" });
    return false;
  }
  if (!isMobile.value) {
    store.commit("showRegister");
  } else {
    router.push({ name: "register" });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['box', { mobileSize: _unref(isMobile) }])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("topic.your_friend", {
          userName: userName.value,
        })), 1),
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t("topic.reg_to_points")), 1),
      _createElementVNode("span", null, [
        _createElementVNode("b", null, _toDisplayString(_ctx.$t("topic.free_7day")), 1)
      ])
    ]),
    _createElementVNode("div", {
      class: "shadowBtn",
      onClick: showRegister
    }, _toDisplayString(_ctx.$t("topic.sign_up")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("topic.features")), 1),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, _toDisplayString(_ctx.$t("topic.content1")), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$t("topic.content2")), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$t("topic.content3")), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$t("topic.content4")), 1)
      ])
    ])
  ], 2))
}
}

})